(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3931],{

/***/ 21815:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "z3": function() { return /* binding */ ButtonLinkTag; }
/* harmony export */ });
/* unused harmony export ButtonLinkName */
/* harmony import */ var _tiptap_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(56059);
/* harmony import */ var _tiptap_react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95258);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(37326);



var ButtonLinkName = "linkButton";
var ButtonLinkTag = "link-button";
/* harmony default export */ __webpack_exports__["ZP"] = (_tiptap_core__WEBPACK_IMPORTED_MODULE_1__/* .Node.create */ .NB.create({
    name: ButtonLinkName,
    group: "block",
    atom: true,
    addAttributes: function addAttributes() {
        return {
            href: {
                default: ""
            },
            label: {
                default: ""
            }
        };
    },
    parseHTML: function parseHTML() {
        return [
            {
                tag: ButtonLinkTag
            }, 
        ];
    },
    renderHTML: function renderHTML(param) {
        var HTMLAttributes = param.HTMLAttributes;
        return [
            ButtonLinkTag,
            (0,_tiptap_core__WEBPACK_IMPORTED_MODULE_1__/* .mergeAttributes */ .P1)(HTMLAttributes)
        ];
    },
    addNodeView: function addNodeView() {
        return (0,_tiptap_react__WEBPACK_IMPORTED_MODULE_2__/* .ReactNodeViewRenderer */ .fW)(___WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z);
    }
}));


/***/ }),

/***/ 37326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ EditorButtonLink; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _tiptap_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(95258);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _lib_classnames__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(370);
/* harmony import */ var _elements_Button__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74340);
/* harmony import */ var _Tiptap_module_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(832);
/* harmony import */ var _Tiptap_module_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Tiptap_module_css__WEBPACK_IMPORTED_MODULE_5__);






function EditorButtonLink(param) {
    var node = param.node;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_tiptap_react__WEBPACK_IMPORTED_MODULE_3__/* .NodeViewWrapper */ .T5, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "flex justify-center w-full",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Button__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                onClick: function() {
                    return window.open(node.attrs.href, "_blank");
                },
                className: (0,_lib_classnames__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)("mx-1", (_Tiptap_module_css__WEBPACK_IMPORTED_MODULE_5___default().editorButton)),
                children: node.attrs.label
            })
        })
    });
}


/***/ }),

/***/ 21475:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Sl": function() { return /* binding */ MailLinkButtonTag; },
  "ZP": function() { return /* binding */ ExtensionMailButtonLink; }
});

// UNUSED EXPORTS: MailLinkButtonName

// EXTERNAL MODULE: ./node_modules/@tiptap/core/dist/tiptap-core.esm.js + 2 modules
var tiptap_core_esm = __webpack_require__(56059);
// EXTERNAL MODULE: ./node_modules/@tiptap/react/dist/tiptap-react.esm.js
var tiptap_react_esm = __webpack_require__(95258);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/Tiptap/Extensions/ButtonLinkWrapper/index.tsx
var ButtonLinkWrapper = __webpack_require__(37326);
;// CONCATENATED MODULE: ./components/Tiptap/Extensions/MailButtonLink/index.tsx



function MailButtonLink(param) {
    var node = param.node;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ButtonLinkWrapper/* default */.Z, {
        node: node
    });
}

;// CONCATENATED MODULE: ./components/Tiptap/Extensions/MailButtonLink/ExtensionMailButtonLink.ts



var MailLinkButtonName = "mailLinkButton";
var MailLinkButtonTag = "mail-link-button";
/* harmony default export */ var ExtensionMailButtonLink = (tiptap_core_esm/* Node.create */.NB.create({
    name: MailLinkButtonName,
    group: "block",
    atom: true,
    addAttributes: function addAttributes() {
        return {
            href: {
                default: undefined
            },
            label: {
                default: undefined
            }
        };
    },
    parseHTML: function parseHTML() {
        return [
            {
                tag: MailLinkButtonTag
            }, 
        ];
    },
    renderHTML: function renderHTML(param) {
        var HTMLAttributes = param.HTMLAttributes;
        return [
            MailLinkButtonTag,
            (0,tiptap_core_esm/* mergeAttributes */.P1)(HTMLAttributes)
        ];
    },
    addNodeView: function addNodeView() {
        return (0,tiptap_react_esm/* ReactNodeViewRenderer */.fW)(MailButtonLink);
    }
}));


/***/ }),

/***/ 71204:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "qd": function() { return /* binding */ PaywallName; },
  "ew": function() { return /* binding */ PaywallTag; },
  "ZP": function() { return /* binding */ ExtensionPaywallWrapper; }
});

// EXTERNAL MODULE: ./node_modules/@tiptap/core/dist/tiptap-core.esm.js + 2 modules
var tiptap_core_esm = __webpack_require__(56059);
// EXTERNAL MODULE: ./node_modules/@tiptap/react/dist/tiptap-react.esm.js
var tiptap_react_esm = __webpack_require__(95258);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./lib/helper/helper.ts + 5 modules
var helper = __webpack_require__(20878);
// EXTERNAL MODULE: ./config/routes.tsx + 2 modules
var routes = __webpack_require__(6635);
// EXTERNAL MODULE: ./lib/classnames.ts
var classnames = __webpack_require__(370);
// EXTERNAL MODULE: ./components/basic/Card/index.tsx
var Card = __webpack_require__(80258);
// EXTERNAL MODULE: ./components/elements/Heading/Heading2/index.tsx
var Heading2 = __webpack_require__(51859);
// EXTERNAL MODULE: ./components/elements/Link/index.tsx
var Link = __webpack_require__(6553);
;// CONCATENATED MODULE: ./components/svgs/illustrations/sub-star.svg
var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgSubStar = function SvgSubStar(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    viewBox: "0 0 450 411",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/react.createElement("path", {
    d: "M298.436 7H151.564a71.251 71.251 0 0 0-62.106 36.09L16.442 169.83a72.102 72.102 0 0 0 0 71.342l73.016 126.738A71.922 71.922 0 0 0 151.564 404h146.872a71.26 71.26 0 0 0 62.106-36.091l73.016-126.738a72.103 72.103 0 0 0 0-71.342L360.542 43.091A71.919 71.919 0 0 0 298.436 7Z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.114 10.589A78.208 78.208 0 0 1 151.549 0c.003 0-.002 0 0 0h146.908v6.943l-.025 6.934h.012H151.53a64.33 64.33 0 0 0-56.076 32.588l-.023.04L22.412 173.25l-6.03-3.433 6.012 3.464.01-.016a65.19 65.19 0 0 0 0 64.469l-.01-.017-6.01 3.464 6.028-3.433 73.02 126.746a65.003 65.003 0 0 0 56.128 32.628h-.017v6.938l.025-6.938H298.47a64.34 64.34 0 0 0 56.076-32.588l.023-.04 73.019-126.746 6.028 3.433-6.01-3.464-.01.016a65.181 65.181 0 0 0 .001-64.467l.009.015 6.011-3.464-6.029 3.433-73.019-126.746a65.006 65.006 0 0 0-56.125-32.627h.013V6.942L298.481 0a78.878 78.878 0 0 1 68.111 39.577l73.055 126.808a79.066 79.066 0 0 1-.001 78.23l-.017.031-73.015 126.738-.011.021A78.222 78.222 0 0 1 298.457 411H151.518a78.878 78.878 0 0 1-68.11-39.577m0 0L10.353 244.615a79.062 79.062 0 0 1 0-78.23l.018-.031L83.386 39.616l.01-.02a78.217 78.217 0 0 1 28.718-29.007m254.478 28.988c.001.002-.002-.002 0 0Z",
    fill: "#1D4ED8"
  })), _path3 || (_path3 = /*#__PURE__*/react.createElement("path", {
    d: "m252.172 123.542 19.309 37.811a13.348 13.348 0 0 0 10.073 7.563l41.974 6.722a14.01 14.01 0 0 1 6.71 3.26 14.039 14.039 0 0 1 .846 20.267l-29.382 30.249a15.714 15.714 0 0 0-4.197 11.763l6.715 42.013a13.953 13.953 0 0 1-5.755 13.244 13.926 13.926 0 0 1-14.392 1.04l-37.777-19.325a16.767 16.767 0 0 0-12.592 0l-37.777 19.325a13.926 13.926 0 0 1-19.115-6.858 13.953 13.953 0 0 1-1.032-7.426l6.716-42.013a13.03 13.03 0 0 0-4.198-11.763l-29.382-30.249a14.045 14.045 0 0 1-3.244-14.023 14.039 14.039 0 0 1 4.09-6.244 14.01 14.01 0 0 1 6.71-3.26l41.974-6.722a13.354 13.354 0 0 0 10.073-7.563l19.309-37.811A13.599 13.599 0 0 1 240 116a13.592 13.592 0 0 1 12.172 7.542Z",
    fill: "#C3DDFD"
  })), _path4 || (_path4 = /*#__PURE__*/react.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226 121.87a7.257 7.257 0 0 0-6.122 3.36l-19.145 37.421a20.292 20.292 0 0 1-15.236 11.348l-41.883 6.695a7.082 7.082 0 0 0-5.547 8.545 7.074 7.074 0 0 0 1.786 3.3l.01.011 29.219 30.024a19.93 19.93 0 0 1 6.235 17.828l-6.706 41.87a6.998 6.998 0 0 0 10.133 7.092l37.797-19.299c.181-.093.367-.178.556-.254a23.76 23.76 0 0 1 17.806 0c.189.076.375.161.556.254l37.797 19.299a7.006 7.006 0 0 0 9.605-3.439c.5-1.149.682-2.411.528-3.653l-6.704-41.86a6.845 6.845 0 0 1-.072-.64 22.592 22.592 0 0 1 1.27-9.097 22.629 22.629 0 0 1 4.786-7.843l.093-.098 29.375-30.184.01-.011a7.073 7.073 0 0 0-.438-10.213 7.082 7.082 0 0 0-3.323-1.632l-41.859-6.691a20.315 20.315 0 0 1-9.1-3.821 20.292 20.292 0 0 1-6.16-7.531l-19.145-37.421a7.249 7.249 0 0 0-6.122-3.36Zm-10.424-11.124a21.155 21.155 0 0 1 20.847 0 21.126 21.126 0 0 1 7.713 7.524c.08.133.155.268.225.406l19.32 37.763c.038.075.075.15.111.227a6.405 6.405 0 0 0 4.841 3.627l.043.006 42 6.714.165.028a20.977 20.977 0 0 1 10.036 4.869 20.931 20.931 0 0 1 1.265 30.256l-.025.026-29.346 30.155a8.762 8.762 0 0 0-2.318 6.238l6.661 41.595.025.17a20.852 20.852 0 0 1-8.626 19.811 20.902 20.902 0 0 1-21.57 1.557l-37.494-19.145a9.866 9.866 0 0 0-6.898 0l-37.491 19.144a20.902 20.902 0 0 1-21.573-1.556 20.852 20.852 0 0 1-8.626-19.811l.025-.17 6.718-41.949c0-.001 0 .002 0 0a6.089 6.089 0 0 0-.279-2.992 6.077 6.077 0 0 0-1.682-2.492 6.89 6.89 0 0 1-.36-.345l-29.425-30.236a20.931 20.931 0 0 1 1.265-30.256 20.977 20.977 0 0 1 10.036-4.869l.165-.028 42.043-6.72a6.417 6.417 0 0 0 4.841-3.627c.036-.077.072-.152.111-.227l19.32-37.763c.07-.138.145-.273.225-.406a21.131 21.131 0 0 1 7.712-7.524Z",
    fill: "#1D4ED8"
  })));
};

/* harmony default export */ var sub_star = (SvgSubStar);
// EXTERNAL MODULE: ./components/modules/SubscriberFormInput/index.tsx
var SubscriberFormInput = __webpack_require__(54177);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_throw.mjs
var _throw = __webpack_require__(51351);
;// CONCATENATED MODULE: ./components/modules/Posts/PayWall/PayWallBlock/index.tsx


function PayWallBlock(param) {
    var param = param !== null ? param : (0,_throw/* default */.Z)(new TypeError("Cannot destructure undefined"));
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: " w-full h-[250px] bg-gradient-to-t from-white via-white/70 dark:from-gray-900 dark:via-gray-900/80 to-transparence"
    });
}

;// CONCATENATED MODULE: ./components/modules/Posts/PayWall/index.tsx









// TODO this flag (showHeaderBlur) might be added later
function PayWall(param) {
    var _showHeaderBlur = param.showHeaderBlur, showHeaderBlur = _showHeaderBlur === void 0 ? false : _showHeaderBlur, publication = param.publication, // this postId is necessary to easily convert this paywall into a link to this post for the emails
    // eslint-disable-next-line unused-imports/no-unused-vars
    postId = param.postId;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (0,classnames/* default */.Z)({
            "relative w-full z-50 !-mt-[230px]": showHeaderBlur
        }),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (0,classnames/* default */.Z)({
                "grid justify-items-center content-center": showHeaderBlur
            }),
            children: [
                showHeaderBlur && /*#__PURE__*/ (0,jsx_runtime.jsx)(PayWallBlock, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Card/* default */.Z, {
                    className: "border border-blue-700",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-rows-2 grid-cols-none md:grid-rows-none md:grid-cols-2 gap-4",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "flex flex-col gap-5",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading2/* default */.Z, {
                                        className: "!mt-0 !mb-0",
                                        children: "La suite de cet article est r\xe9serv\xe9e aux abonn\xe9s payants."
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriberFormInput/* default */.Z, {
                                        publication: publication,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                            href: routes/* default.login.getUrl */.Z.login.getUrl(),
                                            className: "text-base",
                                            children: "Je suis d\xe9j\xe0 abonn\xe9"
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(sub_star, {
                                className: "w-[200px] h-[200px] justify-self-center md:justify-self-end"
                            })
                        ]
                    })
                })
            ]
        })
    });
}

// EXTERNAL MODULE: ./components/modules/SubscriberFormInput/SubscriberFormInput.service.ts
var SubscriberFormInput_service = __webpack_require__(32068);
;// CONCATENATED MODULE: ./components/Tiptap/Extensions/PaywallWrapper/index.tsx






function PaywallWrapper(param) {
    var node = param.node;
    if (!(0,helper/* isValidJSON */.tp)(node.attrs.publication)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(tiptap_react_esm/* NodeViewWrapper */.T5, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PayWall, {
            publication: (0,SubscriberFormInput_service/* parsePublicationForSubscriberInput */.hL)(node.attrs.publication),
            postId: node.attrs.postId
        })
    });
}

;// CONCATENATED MODULE: ./components/Tiptap/Extensions/PaywallWrapper/ExtensionPaywallWrapper.ts



var PaywallName = "paywallWrapper";
var PaywallTag = "paywall-wrapper";
/* harmony default export */ var ExtensionPaywallWrapper = (tiptap_core_esm/* Node.create */.NB.create({
    name: PaywallName,
    group: "block",
    atom: true,
    addAttributes: function addAttributes() {
        return {
            publication: {
                default: undefined
            },
            postId: {
                default: undefined
            }
        };
    },
    parseHTML: function parseHTML() {
        return [
            {
                tag: PaywallTag
            }, 
        ];
    },
    renderHTML: function renderHTML(param) {
        var HTMLAttributes = param.HTMLAttributes;
        return [
            PaywallTag,
            (0,tiptap_core_esm/* mergeAttributes */.P1)(HTMLAttributes)
        ];
    },
    addNodeView: function addNodeView() {
        return (0,tiptap_react_esm/* ReactNodeViewRenderer */.fW)(PaywallWrapper);
    }
}));


/***/ }),

/***/ 71111:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "dQ": function() { return /* binding */ SubscribeFormTag; },
  "ZP": function() { return /* binding */ ExtensionSubscribeFormWrapper; }
});

// UNUSED EXPORTS: SubscribeFormName

// EXTERNAL MODULE: ./node_modules/@tiptap/core/dist/tiptap-core.esm.js + 2 modules
var tiptap_core_esm = __webpack_require__(56059);
// EXTERNAL MODULE: ./node_modules/@tiptap/react/dist/tiptap-react.esm.js
var tiptap_react_esm = __webpack_require__(95258);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./lib/helper/helper.ts + 5 modules
var helper = __webpack_require__(20878);
// EXTERNAL MODULE: ./components/modules/SubscriberForm/index.tsx + 2 modules
var SubscriberForm = __webpack_require__(65773);
// EXTERNAL MODULE: ./components/modules/SubscriberFormInput/SubscriberFormInput.service.ts
var SubscriberFormInput_service = __webpack_require__(32068);
// EXTERNAL MODULE: ./components/Tiptap/Tiptap.module.css
var Tiptap_module = __webpack_require__(832);
var Tiptap_module_default = /*#__PURE__*/__webpack_require__.n(Tiptap_module);
;// CONCATENATED MODULE: ./components/Tiptap/Extensions/SubscribeFormWrapper/index.tsx







function SubscribeFormWrapper(param) {
    var node = param.node;
    if (!(0,helper/* isValidJSON */.tp)(node.attrs.publication)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(tiptap_react_esm/* NodeViewWrapper */.T5, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscriberForm/* default */.Z, {
            buttonClassName: (Tiptap_module_default()).editorButton,
            publication: (0,SubscriberFormInput_service/* parsePublicationForSubscriberInput */.hL)(node.attrs.publication),
            alreadySubscribeClassName: "text-center"
        })
    });
}

;// CONCATENATED MODULE: ./components/Tiptap/Extensions/SubscribeFormWrapper/ExtensionSubscribeFormWrapper.ts



var SubscribeFormName = "subscribeFormWrapper";
var SubscribeFormTag = "subscribe-form-wrapper";
/* harmony default export */ var ExtensionSubscribeFormWrapper = (tiptap_core_esm/* Node.create */.NB.create({
    name: SubscribeFormName,
    group: "block",
    atom: true,
    addAttributes: function addAttributes() {
        return {
            publication: {
                default: undefined
            },
            postId: {
                default: undefined
            }
        };
    },
    parseHTML: function parseHTML() {
        return [
            {
                tag: SubscribeFormTag
            }, 
        ];
    },
    renderHTML: function renderHTML(param) {
        var HTMLAttributes = param.HTMLAttributes;
        return [
            SubscribeFormTag,
            (0,tiptap_core_esm/* mergeAttributes */.P1)(HTMLAttributes)
        ];
    },
    addNodeView: function addNodeView() {
        return (0,tiptap_react_esm/* ReactNodeViewRenderer */.fW)(SubscribeFormWrapper);
    }
}));


/***/ }),

/***/ 6479:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "EU": function() { return /* binding */ SubscribeToPaidOfferTag; },
  "ZP": function() { return /* binding */ ExtensionSubscribeToPaidOfferWrapper; },
  "VJ": function() { return /* binding */ formatPublicationForSubscriberToPaidOffer; }
});

// UNUSED EXPORTS: SubscribeToPaidOfferName

// EXTERNAL MODULE: ./node_modules/@tiptap/core/dist/tiptap-core.esm.js + 2 modules
var tiptap_core_esm = __webpack_require__(56059);
// EXTERNAL MODULE: ./node_modules/@tiptap/react/dist/tiptap-react.esm.js
var tiptap_react_esm = __webpack_require__(95258);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./lib/helper/helper.ts + 5 modules
var helper = __webpack_require__(20878);
// EXTERNAL MODULE: ./components/modules/SubscriberForm/SubscribeToPaidOffer/index.tsx + 1 modules
var SubscribeToPaidOffer = __webpack_require__(62224);
;// CONCATENATED MODULE: ./components/Tiptap/Extensions/SubscribeToPaidOfferWrapper/index.tsx





function parsePublicationForSubscribeToPaidOffer(publicationAsString) {
    return JSON.parse(publicationAsString);
}
function SubscribeToPaidOfferWrapper(param) {
    var node = param.node;
    if (!(0,helper/* isValidJSON */.tp)(node.attrs.publication)) {
        return null;
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(tiptap_react_esm/* NodeViewWrapper */.T5, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(SubscribeToPaidOffer/* default */.Z, {
            publication: parsePublicationForSubscribeToPaidOffer(node.attrs.publication)
        })
    });
}

;// CONCATENATED MODULE: ./components/Tiptap/Extensions/SubscribeToPaidOfferWrapper/ExtensionSubscribeToPaidOfferWrapper.ts



function formatPublicationForSubscriberToPaidOffer(publication) {
    return JSON.stringify(publication);
}
var SubscribeToPaidOfferName = "subscribeToPaidOfferWrapper";
var SubscribeToPaidOfferTag = "subscribe-to-paid-offer-wrapper";
/* harmony default export */ var ExtensionSubscribeToPaidOfferWrapper = (tiptap_core_esm/* Node.create */.NB.create({
    name: SubscribeToPaidOfferName,
    group: "block",
    atom: true,
    addAttributes: function addAttributes() {
        return {
            publication: {
                default: undefined
            },
            postId: {
                default: undefined
            },
            price: {
                default: undefined
            }
        };
    },
    parseHTML: function parseHTML() {
        return [
            {
                tag: SubscribeToPaidOfferTag
            }, 
        ];
    },
    renderHTML: function renderHTML(param) {
        var HTMLAttributes = param.HTMLAttributes;
        return [
            SubscribeToPaidOfferTag,
            (0,tiptap_core_esm/* mergeAttributes */.P1)(HTMLAttributes)
        ];
    },
    addNodeView: function addNodeView() {
        return (0,tiptap_react_esm/* ReactNodeViewRenderer */.fW)(SubscribeToPaidOfferWrapper);
    }
}));


/***/ }),

/***/ 2886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Tiptap; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@tiptap/react/dist/tiptap-react.esm.js
var tiptap_react_esm = __webpack_require__(95258);
// EXTERNAL MODULE: ./lib/classnames.ts
var classnames = __webpack_require__(370);
// EXTERNAL MODULE: ./components/basic/Prose/index.tsx
var Prose = __webpack_require__(70952);
// EXTERNAL MODULE: ./components/Tiptap/isEditorModeContext.ts
var isEditorModeContext = __webpack_require__(70995);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/node_modules/tslib/tslib.es6.js
var tslib_es6 = __webpack_require__(20414);
// EXTERNAL MODULE: ./node_modules/bootstrap-icons/icons/arrow-clockwise.svg
var arrow_clockwise = __webpack_require__(79840);
// EXTERNAL MODULE: ./node_modules/bootstrap-icons/icons/arrow-counterclockwise.svg
var arrow_counterclockwise = __webpack_require__(66610);
// EXTERNAL MODULE: ./node_modules/bootstrap-icons/icons/card-image.svg
var card_image = __webpack_require__(53524);
// EXTERNAL MODULE: ./node_modules/bootstrap-icons/icons/code-slash.svg
var code_slash = __webpack_require__(13253);
// EXTERNAL MODULE: ./node_modules/bootstrap-icons/icons/link-45deg.svg
var link_45deg = __webpack_require__(63165);
// EXTERNAL MODULE: ./node_modules/bootstrap-icons/icons/list-ol.svg
var list_ol = __webpack_require__(35626);
// EXTERNAL MODULE: ./node_modules/bootstrap-icons/icons/paragraph.svg
var paragraph = __webpack_require__(36841);
// EXTERNAL MODULE: ./node_modules/bootstrap-icons/icons/quote.svg
var quote = __webpack_require__(73906);
// EXTERNAL MODULE: ./node_modules/bootstrap-icons/icons/text-center.svg
var text_center = __webpack_require__(7163);
// EXTERNAL MODULE: ./node_modules/bootstrap-icons/icons/text-left.svg
var text_left = __webpack_require__(17288);
// EXTERNAL MODULE: ./node_modules/bootstrap-icons/icons/text-right.svg
var text_right = __webpack_require__(64335);
// EXTERNAL MODULE: ./node_modules/bootstrap-icons/icons/type-bold.svg
var type_bold = __webpack_require__(46320);
// EXTERNAL MODULE: ./node_modules/bootstrap-icons/icons/type-h1.svg
var type_h1 = __webpack_require__(19933);
// EXTERNAL MODULE: ./node_modules/bootstrap-icons/icons/type-h2.svg
var type_h2 = __webpack_require__(95801);
// EXTERNAL MODULE: ./node_modules/bootstrap-icons/icons/type-h3.svg
var type_h3 = __webpack_require__(96823);
// EXTERNAL MODULE: ./node_modules/bootstrap-icons/icons/type-italic.svg
var type_italic = __webpack_require__(12329);
// EXTERNAL MODULE: ./node_modules/bootstrap-icons/icons/type-underline.svg
var type_underline = __webpack_require__(6032);
// EXTERNAL MODULE: ./node_modules/bootstrap-icons/icons/youtube.svg
var youtube = __webpack_require__(64999);
// EXTERNAL MODULE: ./node_modules/next-auth/react/index.js
var react = __webpack_require__(33299);
// EXTERNAL MODULE: ./node_modules/react/index.js
var node_modules_react = __webpack_require__(67294);
// EXTERNAL MODULE: ./lib/helper/helper.ts + 5 modules
var helper = __webpack_require__(20878);
// EXTERNAL MODULE: ./lib/request.ts
var request = __webpack_require__(87888);
// EXTERNAL MODULE: ./components/basic/Dropdown/index.tsx
var Dropdown = __webpack_require__(28086);
// EXTERNAL MODULE: ./components/elements/Button/index.tsx
var Button = __webpack_require__(74340);
;// CONCATENATED MODULE: ./components/svgs/illustrations/unlink-thin.svg
var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgUnlinkThin = function SvgUnlinkThin(props) {
  return /*#__PURE__*/node_modules_react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/node_modules_react.createElement("path", {
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/node_modules_react.createElement("path", {
    d: "m17.657 14.828-1.414-1.414L17.657 12A4 4 0 1 0 12 6.343l-1.414 1.414-1.414-1.414 1.414-1.414a6 6 0 0 1 8.485 8.485l-1.414 1.414zm-2.829 2.829-1.414 1.414a6 6 0 1 1-8.485-8.485l1.414-1.414 1.414 1.414L6.343 12A4 4 0 1 0 12 17.657l1.414-1.414 1.414 1.414zm0-9.9 1.415 1.415-7.071 7.07-1.415-1.414 7.071-7.07zM5.775 2.293l1.932-.518L8.742 5.64l-1.931.518-1.036-3.864zm9.483 16.068 1.931-.518 1.036 3.864-1.932.518-1.035-3.864zM2.293 5.775l3.864 1.036-.518 1.931-3.864-1.035.518-1.932zm16.068 9.483 3.864 1.035-.518 1.932-3.864-1.036.518-1.931z"
  })));
};

/* harmony default export */ var unlink_thin = (SvgUnlinkThin);
// EXTERNAL MODULE: ./components/Tiptap/MenuBar/MenuBar.module.css
var MenuBar_module = __webpack_require__(47727);
var MenuBar_module_default = /*#__PURE__*/__webpack_require__.n(MenuBar_module);
// EXTERNAL MODULE: ./config/routes.tsx + 2 modules
var routes = __webpack_require__(6635);
// EXTERNAL MODULE: ./components/Tiptap/Extensions/MailButtonLink/ExtensionMailButtonLink.ts + 1 modules
var ExtensionMailButtonLink = __webpack_require__(21475);
// EXTERNAL MODULE: ./components/Tiptap/Extensions/PaywallWrapper/ExtensionPaywallWrapper.ts + 4 modules
var ExtensionPaywallWrapper = __webpack_require__(71204);
// EXTERNAL MODULE: ./components/Tiptap/Extensions/SubscribeFormWrapper/ExtensionSubscribeFormWrapper.ts + 1 modules
var ExtensionSubscribeFormWrapper = __webpack_require__(71111);
// EXTERNAL MODULE: ./components/Tiptap/Extensions/SubscribeToPaidOfferWrapper/ExtensionSubscribeToPaidOfferWrapper.ts + 1 modules
var ExtensionSubscribeToPaidOfferWrapper = __webpack_require__(6479);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./components/basic/Card/index.tsx
var Card = __webpack_require__(80258);
// EXTERNAL MODULE: ./components/elements/Forms/Label/index.tsx
var Label = __webpack_require__(4683);
// EXTERNAL MODULE: ./components/elements/Forms/TextInput/index.tsx
var TextInput = __webpack_require__(45214);
// EXTERNAL MODULE: ./components/elements/Heading/Heading2/index.tsx
var Heading2 = __webpack_require__(51859);
// EXTERNAL MODULE: ./components/Tiptap/Extensions/ButtonLinkWrapper/ExtensionButtonLinkWrapper.ts
var ExtensionButtonLinkWrapper = __webpack_require__(21815);
;// CONCATENATED MODULE: ./components/Tiptap/MenuBar/FormCustomButton/index.tsx








function FormCustomButton(param) {
    var editor = param.editor, visible = param.visible, setVisible = param.setVisible;
    var onSubmit = function onSubmit(data) {
        editor.chain().focus().insertContent("<".concat(ExtensionButtonLinkWrapper/* ButtonLinkTag */.z3, " href=").concat(data.href, ' label="').concat(data.label, '"></').concat(ExtensionButtonLinkWrapper/* ButtonLinkTag */.z3, ">")).run();
        setVisible(false);
    };
    var ref, ref1;
    var ref2 = (0,index_esm/* useForm */.cI)({
        defaultValues: {
            label: "",
            href: ""
        }
    }), register = ref2.register, handleSubmit = ref2.handleSubmit, errors = ref2.formState.errors;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: visible && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "md:w-[500px] flex flex-col border absolute top-12 bottom-0 p-2 z-10",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Card/* default */.Z, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Heading2/* default */.Z, {
                        className: "!mt-0",
                        level: 1,
                        children: "Cr\xe9er un bouton"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
                        onSubmit: handleSubmit(onSubmit),
                        className: "p-1 d-flex flex-column gap-2",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                                        htmlFor: "label",
                                        children: "label"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* default */.Z, {
                                        id: "label",
                                        name: "label",
                                        register: register,
                                        errorText: (ref = errors.label) === null || ref === void 0 ? void 0 : ref.message,
                                        className: "w-full"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "mt-4",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.Z, {
                                        htmlFor: "href",
                                        children: "destination"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* default */.Z, {
                                        id: "href",
                                        name: "href",
                                        register: register,
                                        errorText: (ref1 = errors.href) === null || ref1 === void 0 ? void 0 : ref1.message,
                                        className: "w-full"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "flex justify-between",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                                            color: "alternative",
                                            onClick: function() {
                                                return setVisible(false);
                                            },
                                            children: "Cancel"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                                            type: "submit",
                                            children: "Cr\xe9er"
                                        })
                                    ]
                                })
                            })
                        ]
                    })
                ]
            })
        })
    });
}

// EXTERNAL MODULE: ./lib/feature-flags.ts
var feature_flags = __webpack_require__(4136);
;// CONCATENATED MODULE: ./components/Tiptap/MenuBar/MoreButton/MoreButton.service.ts



// this publication needs to be of type SubscriberInputPublication because it will render a SubscriberForm component
function escapeText(rawText) {
    return rawText === null || rawText === void 0 ? void 0 : rawText.replace(/'/g, "’");
}
function formatPublication(publication) {
    return JSON.stringify({
        id: publication.id,
        title: escapeText(publication.title),
        description: publication.description ? escapeText(publication.description) : "",
        subscriberLists: publication.subscriberLists,
        isPaid: publication.isPaid
    });
}
function handlePaidMode(publication, setIsPublicationPaid) {
    return _handlePaidMode.apply(this, arguments);
}
function _handlePaidMode() {
    _handlePaidMode = (0,_async_to_generator/* default */.Z)(function(publication, setIsPublicationPaid) {
        var isPublicationPaid;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        (0,feature_flags/* isPaidModeAvailable */.AO)(publication)
                    ];
                case 1:
                    isPublicationPaid = _state.sent();
                    setIsPublicationPaid(isPublicationPaid);
                    return [
                        2
                    ];
            }
        });
    });
    return _handlePaidMode.apply(this, arguments);
}

;// CONCATENATED MODULE: ./components/Tiptap/MenuBar/MoreButton/index.tsx










function MoreButton(param) {
    var editor = param.editor, postId = param.postId, publication = param.publication;
    var ref = (0,node_modules_react.useState)(false), buttonMakerVisibility = ref[0], setButtonMakerVisibility = ref[1];
    var ref1 = (0,node_modules_react.useState)(false), isPublicationPaid = ref1[0], setIsPublicationPaid = ref1[1];
    (0,node_modules_react.useEffect)(function() {
        handlePaidMode(publication, setIsPublicationPaid);
    }, [
        publication
    ]);
    var links = [
        {
            id: 0,
            children: "Formulaire d’inscription",
            onClick: function() {
                editor.chain().focus().insertContent("<".concat(ExtensionSubscribeFormWrapper/* SubscribeFormTag */.dQ, " publication='").concat(formatPublication(publication), "' postId='").concat(postId, "'></").concat(ExtensionSubscribeFormWrapper/* SubscribeFormTag */.dQ, ">")).run();
            }
        },
        {
            id: 1,
            children: "Bouton personnalis\xe9",
            onClick: function() {
                setButtonMakerVisibility(true);
            }
        },
        {
            id: 2,
            children: "Voir en ligne",
            onClick: function() {
                editor.chain().focus().insertContent("<".concat(ExtensionMailButtonLink/* MailLinkButtonTag */.Sl, ' href="').concat(routes/* default.getPost.getUrl */.Z.getPost.getUrl(publication.id, postId), '" label="Voir en ligne"></').concat(ExtensionMailButtonLink/* MailLinkButtonTag */.Sl, ">")).run();
            }
        },
        {
            id: 3,
            children: "Commenter en ligne",
            onClick: function() {
                editor.chain().focus().insertContent("<".concat(ExtensionMailButtonLink/* MailLinkButtonTag */.Sl, ' href="').concat(routes/* default.getPost.getUrl */.Z.getPost.getUrl(publication.id, postId), '/#comments" label="Commenter en ligne"></').concat(ExtensionMailButtonLink/* MailLinkButtonTag */.Sl, ">")).run();
            }
        }, 
    ];
    if (isPublicationPaid) {
        links.push({
            id: 4,
            children: "Ajouter un paywall",
            onClick: function() {
                editor.chain().focus().insertContent("<".concat(ExtensionPaywallWrapper/* PaywallTag */.ew, " publication='").concat(formatPublication(publication), "' postId='").concat(postId, "'></").concat(ExtensionPaywallWrapper/* PaywallTag */.ew, ">")).run();
            }
        }, {
            id: 5,
            children: "Bouton Acc\xe8s complet",
            onClick: function() {
                editor.chain().focus().insertContent("<".concat(ExtensionSubscribeToPaidOfferWrapper/* SubscribeToPaidOfferTag */.EU, " publication='").concat((0,ExtensionSubscribeToPaidOfferWrapper/* formatPublicationForSubscriberToPaidOffer */.VJ)(publication), "' postId='").concat(postId, "'></").concat(ExtensionSubscribeToPaidOfferWrapper/* SubscribeToPaidOfferTag */.EU, ">")).run();
            }
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormCustomButton, {
                editor: editor,
                visible: buttonMakerVisibility,
                setVisible: setButtonMakerVisibility
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                links: links,
                children: "Plus"
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/Tiptap/MenuBar/index.tsx
































function upload(file, userToken) {
    return _upload.apply(this, arguments);
}
function _upload() {
    _upload = (0,_async_to_generator/* default */.Z)(function(file, userToken) {
        var formData, response;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    formData = new FormData();
                    formData.append("files", file);
                    return [
                        4,
                        (0,request/* postAxiosAPI */.pW)("/upload", formData, userToken)
                    ];
                case 1:
                    response = _state.sent();
                    return [
                        2,
                        response.data
                    ];
            }
        });
    });
    return _upload.apply(this, arguments);
}
function setYoutubeVideo(editor) {
    var previousUrl = editor.getAttributes("link").href;
    // eslint-disable-next-line no-alert
    var url = window.prompt("Youtube URL", previousUrl);
    if (url === null || url === "") {
        return;
    }
    editor.commands.setYoutubeVideo({
        src: url
    });
}
function setTextAlign(type, editor) {
    var prefix = (0,helper/* isCurrentBrowserFirefox */.ro)() ? "-moz-" : "-webkit-";
    editor.chain().focus();
    if (editor.isActive({
        textAlign: "".concat(prefix).concat(type)
    })) {
        editor.commands.unsetTextAlign();
    } else {
        editor.commands.setTextAlign("".concat(prefix).concat(type));
    }
}
function MenuBar(param) {
    var editor = param.editor, publication = param.publication, postId = param.postId;
    var hiddenFileInput = (0,node_modules_react.useRef)(null);
    var ref = (0,react.useSession)({
        required: true
    }), session = ref.data;
    function handleChange(e) {
        return _handleChange.apply(this, arguments);
    }
    function _handleChange() {
        _handleChange = (0,_async_to_generator/* default */.Z)(function(e) {
            var ref, ref1, ref2, image, error;
            return (0,tslib_es6.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(e === null || e === void 0 ? void 0 : (ref = e.target) === null || ref === void 0 ? void 0 : (ref1 = ref.files) === null || ref1 === void 0 ? void 0 : ref1[0])) {
                            return [
                                2
                            ];
                        }
                        if (!session) {
                            return [
                                2
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            upload(e.target.files[0], session.jwt)
                        ];
                    case 2:
                        ref2 = _sliced_to_array/* default.apply */.Z.apply(void 0, [
                            _state.sent(),
                            1
                        ]), image = ref2[0];
                        editor.chain().focus().setImage({
                            src: image.url
                        }).run();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        console.error(error);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        });
        return _handleChange.apply(this, arguments);
    }
    var setLink = (0,node_modules_react.useCallback)(function() {
        var previousUrl = editor.getAttributes("link").href;
        // eslint-disable-next-line no-alert
        var url = window.prompt("URL", previousUrl);
        // cancelled
        if (url === null) {
            return;
        }
        // empty
        if (url === "") {
            editor.chain().focus().extendMarkRange("link").unsetLink().run();
            return;
        }
        // update link
        editor.chain().focus().extendMarkRange("link").setLink({
            href: url
        }).run();
    }, [
        editor
    ]);
    if (!editor) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            children: "No editor"
        });
    }
    // TODO add aria label for those icons
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,classnames/* default */.Z)((MenuBar_module_default()).menuBar, "dark:bg-gray-800", {
            "top-[60px] md:top-[95px] bg-white z-10 !sticky": publication
        }),
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                color: "borderless",
                onClick: function() {
                    return editor.chain().focus().toggleBold().run();
                },
                className: editor.isActive("bold") ? "is-active" : "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(type_bold/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                color: "borderless",
                onClick: function() {
                    return editor.chain().focus().toggleItalic().run();
                },
                className: editor.isActive("italic") ? "is-active" : "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(type_italic/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                color: "borderless",
                onClick: function() {
                    return editor.chain().focus().toggleCode().run();
                },
                className: editor.isActive("code") ? "is-active" : "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(code_slash/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                color: "borderless",
                onClick: setLink,
                className: editor.isActive("link") ? "is-active" : "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(link_45deg/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                color: "borderless",
                onClick: function() {
                    return editor.chain().focus().unsetLink().run();
                },
                disabled: !editor.isActive("link"),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(unlink_thin, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                color: "borderless",
                onClick: function() {
                    return setYoutubeVideo(editor);
                },
                className: editor.isActive("youtube") ? "is-active" : "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(youtube/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (MenuBar_module_default()).divider
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                color: "borderless",
                onClick: function() {
                    return setTextAlign("left", editor);
                },
                className: editor.isActive({
                    textAlign: "left"
                }) ? "is-active" : "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_left/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                color: "borderless",
                onClick: function() {
                    return setTextAlign("center", editor);
                },
                className: editor.isActive({
                    textAlign: "center"
                }) ? "is-active" : "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_center/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                color: "borderless",
                onClick: function() {
                    return setTextAlign("right", editor);
                },
                className: editor.isActive({
                    textAlign: "right"
                }) ? "is-active" : "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(text_right/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (MenuBar_module_default()).divider
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                color: "borderless",
                onClick: function() {
                    var ref;
                    return hiddenFileInput === null || hiddenFileInput === void 0 ? void 0 : (ref = hiddenFileInput.current) === null || ref === void 0 ? void 0 : ref.click();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(card_image/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                ref: hiddenFileInput,
                type: "file",
                id: "file-input",
                accept: "image/*",
                onChange: handleChange,
                style: {
                    display: "none"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                color: "borderless",
                onClick: function() {
                    return editor.chain().focus().toggleUnderline().run();
                },
                className: editor.isActive("underline") ? "is-active" : "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(type_underline/* default */.Z, {})
            }),
            publication && /*#__PURE__*/ (0,jsx_runtime.jsx)(MoreButton, {
                editor: editor,
                publication: publication,
                postId: postId
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Dropdown/* default */.Z, {
                links: [
                    {
                        id: 0,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(paragraph/* default */.Z, {}),
                        onClick: function() {
                            editor.chain().focus().setParagraph().run();
                        }
                    },
                    {
                        id: 1,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(type_h1/* default */.Z, {}),
                        onClick: function() {
                            editor.chain().focus().toggleHeading({
                                level: 1
                            }).run();
                        }
                    },
                    {
                        id: 2,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(type_h2/* default */.Z, {}),
                        onClick: function() {
                            editor.chain().focus().toggleHeading({
                                level: 2
                            }).run();
                        }
                    },
                    {
                        id: 3,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(type_h3/* default */.Z, {}),
                        onClick: function() {
                            editor.chain().focus().toggleHeading({
                                level: 3
                            }).run();
                        }
                    }, 
                ],
                children: "Styles"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                color: "borderless",
                onClick: function() {
                    return editor.chain().focus().toggleBulletList().run();
                },
                className: editor.isActive("bulletList") ? "is-active" : "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(list_ol/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                color: "borderless",
                onClick: function() {
                    return editor.chain().focus().toggleOrderedList().run();
                },
                className: editor.isActive("orderedList") ? "is-active" : "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(list_ol/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                color: "borderless",
                onClick: function() {
                    return editor.chain().focus().toggleBlockquote().run();
                },
                className: editor.isActive("blockquote") ? "is-active" : "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(quote/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (MenuBar_module_default()).divider
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                color: "borderless",
                onClick: function() {
                    return editor.chain().focus().undo().run();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_counterclockwise/* default */.Z, {})
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.ZP, {
                color: "borderless",
                onClick: function() {
                    return editor.chain().focus().redo().run();
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_clockwise/* default */.Z, {})
            })
        ]
    });
}

;// CONCATENATED MODULE: ./components/Tiptap/index.tsx






function Tiptap(param) {
    var editor = param.editor, publication = param.publication, _postId = param.postId, postId = _postId === void 0 ? "__postId__" : _postId;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            (editor === null || editor === void 0 ? void 0 : editor.isEditable) && /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuBar, {
                editor: editor,
                publication: publication,
                postId: postId
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Prose/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(isEditorModeContext/* default.Provider */.Z.Provider, {
                    value: (editor === null || editor === void 0 ? void 0 : editor.isEditable) || false,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(tiptap_react_esm/* EditorContent */.kg, {
                        editor: editor,
                        className: (0,classnames/* default */.Z)({
                            tiptapViewer: !(editor === null || editor === void 0 ? void 0 : editor.isEditable)
                        })
                    })
                })
            })
        ]
    });
}


/***/ }),

/***/ 25877:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "R": function() { return /* binding */ extensions; },
  "T": function() { return /* binding */ renderTiptap; }
});

// EXTERNAL MODULE: ./node_modules/@tiptap/extension-color/dist/tiptap-extension-color.esm.js
var tiptap_extension_color_esm = __webpack_require__(50190);
// EXTERNAL MODULE: ./node_modules/@tiptap/extension-link/dist/tiptap-extension-link.esm.js + 1 modules
var tiptap_extension_link_esm = __webpack_require__(26950);
// EXTERNAL MODULE: ./node_modules/@tiptap/extension-text-align/dist/tiptap-extension-text-align.esm.js
var tiptap_extension_text_align_esm = __webpack_require__(6528);
// EXTERNAL MODULE: ./node_modules/@tiptap/extension-text-style/dist/tiptap-extension-text-style.esm.js
var tiptap_extension_text_style_esm = __webpack_require__(81335);
// EXTERNAL MODULE: ./node_modules/@tiptap/extension-underline/dist/tiptap-extension-underline.esm.js
var tiptap_extension_underline_esm = __webpack_require__(53237);
// EXTERNAL MODULE: ./node_modules/@tiptap/extension-youtube/dist/tiptap-extension-youtube.esm.js
var tiptap_extension_youtube_esm = __webpack_require__(69574);
// EXTERNAL MODULE: ./node_modules/@tiptap/html/dist/tiptap-html.esm.js + 4 modules
var tiptap_html_esm = __webpack_require__(29951);
// EXTERNAL MODULE: ./node_modules/@tiptap/starter-kit/dist/tiptap-starter-kit.esm.js + 22 modules
var tiptap_starter_kit_esm = __webpack_require__(39212);
// EXTERNAL MODULE: ./lib/helper/helper.ts + 5 modules
var helper = __webpack_require__(20878);
// EXTERNAL MODULE: ./components/Tiptap/Extensions/ButtonLinkWrapper/ExtensionButtonLinkWrapper.ts
var ExtensionButtonLinkWrapper = __webpack_require__(21815);
// EXTERNAL MODULE: ./node_modules/@tiptap/extension-image/dist/tiptap-extension-image.esm.js
var tiptap_extension_image_esm = __webpack_require__(92943);
// EXTERNAL MODULE: ./node_modules/@tiptap/core/dist/tiptap-core.esm.js + 2 modules
var tiptap_core_esm = __webpack_require__(56059);
;// CONCATENATED MODULE: ./components/Tiptap/Extensions/CustomImage/index.tsx


var CustomImage = tiptap_extension_image_esm/* Image.extend */.Ee.extend({
    addOptions: function addOptions() {
        return tiptap_extension_image_esm/* Image.options */.Ee.options;
    },
    renderHTML: function renderHTML(param) {
        var HTMLAttributes = param.HTMLAttributes;
        return [
            "figure",
            HTMLAttributes,
            [
                "img",
                (0,tiptap_core_esm/* mergeAttributes */.P1)(this.options.HTMLAttributes, HTMLAttributes)
            ], 
        ];
    }
});
/* harmony default export */ var Extensions_CustomImage = (CustomImage);

// EXTERNAL MODULE: ./components/Tiptap/Extensions/MailButtonLink/ExtensionMailButtonLink.ts + 1 modules
var ExtensionMailButtonLink = __webpack_require__(21475);
// EXTERNAL MODULE: ./components/Tiptap/Extensions/PaywallWrapper/ExtensionPaywallWrapper.ts + 4 modules
var ExtensionPaywallWrapper = __webpack_require__(71204);
// EXTERNAL MODULE: ./components/Tiptap/Extensions/SubscribeFormWrapper/ExtensionSubscribeFormWrapper.ts + 1 modules
var ExtensionSubscribeFormWrapper = __webpack_require__(71111);
// EXTERNAL MODULE: ./components/Tiptap/Extensions/SubscribeToPaidOfferWrapper/ExtensionSubscribeToPaidOfferWrapper.ts + 1 modules
var ExtensionSubscribeToPaidOfferWrapper = __webpack_require__(6479);
// EXTERNAL MODULE: ./node_modules/@tiptap/react/dist/tiptap-react.esm.js
var tiptap_react_esm = __webpack_require__(95258);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-twitter-embed/dist/index.modern.js
var index_modern = __webpack_require__(29512);
;// CONCATENATED MODULE: ./components/Tiptap/Extensions/TwitterEmbed/index.tsx




function TwitterEmbed(param) {
    var node = param.node;
    var getTweetId = function getTweetId(url) {
        var idWithParams = url.split("/").pop();
        if (!idWithParams) {
            return "0";
        }
        return idWithParams.split("?")[0];
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(tiptap_react_esm/* NodeViewWrapper */.T5, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* TwitterTweetEmbed */.iD, {
            tweetId: getTweetId(node.attrs.src)
        })
    });
}

;// CONCATENATED MODULE: ./components/Tiptap/Extensions/TwitterEmbed/utils.ts
var TWITTER_REGEX = /^https?:\/\/twitter\.com\/(?:#!\/)?(\w+)\/status(?:es)?\/(\d+?.*)?$/;
var TWITTER_REGEX_GLOBAL = /^https?:\/\/twitter\.com\/(?:#!\/)?(\w+)\/status(?:es)?\/(\d+?.*)?$/g;
function isValidTwitterUrl(url) {
    return url.match(TWITTER_REGEX);
}

;// CONCATENATED MODULE: ./components/Tiptap/Extensions/TwitterEmbed/ExtensionTwitterEmbed.ts




/* harmony default export */ var ExtensionTwitterEmbed = (tiptap_core_esm/* Node.create */.NB.create({
    name: "twitter-embed",
    addOptions: function addOptions() {
        return {
            addPasteHandler: true,
            allowFullscreen: false,
            controls: true,
            height: 300,
            HTMLAttributes: {},
            inline: false,
            nocookie: false,
            width: 600
        };
    },
    inline: function inline() {
        return this.options.inline;
    },
    group: function group() {
        return this.options.inline ? "inline" : "block";
    },
    atom: true,
    draggable: true,
    addAttributes: function addAttributes() {
        return {
            src: {
                default: undefined
            },
            width: {
                default: this.options.width
            },
            height: {
                default: this.options.height
            }
        };
    },
    addCommands: function addCommands() {
        var _this = this;
        return {
            setTwitterEmbed: function(options) {
                return function(param) {
                    var commands = param.commands;
                    if (!isValidTwitterUrl(options.src)) {
                        return false;
                    }
                    return commands.insertContent({
                        type: _this.name,
                        attrs: options
                    });
                };
            }
        };
    },
    addPasteRules: function addPasteRules() {
        if (!this.options.addPasteHandler) {
            return [];
        }
        return [
            (0,tiptap_core_esm/* nodePasteRule */.Ss)({
                find: TWITTER_REGEX_GLOBAL,
                type: this.type,
                getAttributes: function(match) {
                    return {
                        src: match.input
                    };
                }
            }), 
        ];
    },
    parseHTML: function parseHTML() {
        return [
            {
                tag: "twitter-embed"
            }, 
        ];
    },
    renderHTML: function renderHTML(param) {
        var HTMLAttributes = param.HTMLAttributes;
        return [
            "twitter-embed",
            (0,tiptap_core_esm/* mergeAttributes */.P1)(HTMLAttributes)
        ];
    },
    addNodeView: function addNodeView() {
        return (0,tiptap_react_esm/* ReactNodeViewRenderer */.fW)(TwitterEmbed);
    }
}));

;// CONCATENATED MODULE: ./components/Tiptap/tiptap.service.ts
















var extensions = [
    tiptap_starter_kit_esm/* default */.Z,
    tiptap_extension_underline_esm/* default */.Z,
    tiptap_extension_link_esm/* default.configure */.Z.configure({
        openOnClick: true,
        HTMLAttributes: {
            rel: ""
        }
    }),
    tiptap_extension_youtube_esm/* default.configure */.Z.configure({
        width: 100
    }),
    tiptap_extension_text_style_esm/* default */.Z,
    tiptap_extension_color_esm/* default */.Z,
    tiptap_extension_text_align_esm/* default.configure */.Z.configure({
        types: [
            "heading",
            "paragraph",
            "image"
        ],
        alignments: [
            "left",
            "right",
            "center",
            "-webkit-left",
            "-webkit-center",
            "-webkit-right",
            "-moz-left",
            "-moz-center",
            "-moz-right", 
        ],
        defaultAlignment: "left"
    }),
    Extensions_CustomImage,
    ExtensionButtonLinkWrapper/* default */.ZP,
    ExtensionMailButtonLink/* default */.ZP,
    ExtensionPaywallWrapper/* default */.ZP,
    ExtensionSubscribeFormWrapper/* default */.ZP,
    ExtensionTwitterEmbed,
    ExtensionSubscribeToPaidOfferWrapper/* default */.ZP, 
];
function renderTiptap(content) {
    if (!content) {
        return "";
    }
    if (!(0,helper/* isValidJSON */.tp)(content)) {
        return "<p>Une erreur est survenue, veuillez r\xe9essayer plus tard</p>";
    }
    return (0,tiptap_html_esm/* generateHTML */.a)(JSON.parse(content), extensions);
}


/***/ }),

/***/ 59611:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useEditorInstance; }
/* harmony export */ });
/* harmony import */ var _tiptap_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95258);
/* harmony import */ var _tiptap_service__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(25877);


/**
 * This regex removes the attribute and its values from a text
 * for example: <span style="color: rgb(0, 0, 0)">text</span> will be converted to <span>text</span>
 * @param text
 */ function removeStyleAttribute(text) {
    return text.replace(/(<[^>]+) style=".*?"/gi, "$1");
}
function useEditorInstance(param) {
    var readOnly = param.readOnly, _content = param.content, content = _content === void 0 ? null : _content, onChange = param.onChange;
    return (0,_tiptap_react__WEBPACK_IMPORTED_MODULE_1__/* .useEditor */ .jE)({
        editable: !readOnly,
        extensions: _tiptap_service__WEBPACK_IMPORTED_MODULE_0__/* .extensions */ .R,
        onUpdate: function onUpdate(param) {
            var editor = param.editor;
            onChange === null || onChange === void 0 ? void 0 : onChange(JSON.stringify(editor.getJSON()));
        },
        editorProps: {
            transformPastedHTML: function transformPastedHTML(html) {
                return removeStyleAttribute(html);
            },
            transformPastedText: function transformPastedText(text) {
                return removeStyleAttribute(text);
            }
        },
        content: content
    });
}


/***/ }),

/***/ 80258:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Card; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function Card(param) {
    var children = param.children, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "bg-white border border-gray-100 rounded-lg shadow-md p-6 md:p-11 dark:bg-gray-800 dark:border-gray-700 ".concat(className),
        children: children
    });
}


/***/ }),

/***/ 28086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Dropdown; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _lib_classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(370);
/* harmony import */ var _modules_Navigation_BackendNav_NavOption__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16825);
/* harmony import */ var _GenericDropDown__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95351);




function Dropdown(param) {
    var className = param.className, children = param.children, links = param.links;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_GenericDropDown__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        buttonClassName: (0,_lib_classnames__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("flex items-center justify-between w-full py-2 pl-3 text-xs font-bold text-gray-700 lg:text-sm dark:text-gray-400 dark:hover:text-white dark:focus:text-white md:p-0 md:w-auto md:hover:text-blue-700 md:hover:bg-transparent md:dark:hover:bg-transparent", className),
        buttonNode: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
            children: [
                children,
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                    className: "w-4 h-4 ml-1",
                    fill: "currentColor",
                    viewBox: "0 0 20 20",
                    xmlns: "http://www.w3.org/2000/svg",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                        fillRule: "evenodd",
                        d: "M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z",
                        clipRule: "evenodd"
                    })
                })
            ]
        }),
        itemsClassName: "mt-2 w-44 bg-white rounded divide-y divide-gray-100 shadow dark:bg-gray-700 dark:divide-gray-600",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
            className: "py-1 text-sm text-gray-700 dark:text-gray-400",
            children: links.map(function(link) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules_Navigation_BackendNav_NavOption__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                        getUrl: link.getUrl,
                        onClick: link.onClick,
                        className: "block px-4 py-2 text-left text-sm dark:text-gray-300 dark:hover:text-white hover:bg-gray-100 dark:hover:bg-gray-600",
                        children: link.children
                    })
                }, link.id);
            })
        })
    });
}


/***/ }),

/***/ 95351:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ GenericDropDown; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(82670);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _lib_classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(370);




function getStyle(emplacement, buttonWidth, buttonHeight, gap) {
    if (emplacement === "bottom") {
        return {
            left: "".concat(buttonWidth / 2, "px"),
            top: "".concat(buttonHeight + gap, "px"),
            transform: "translateX(-50%)"
        };
    }
    if (emplacement === "top") {
        return {
            left: "".concat(buttonWidth / 2, "px"),
            bottom: "".concat(buttonHeight + gap, "px"),
            transform: "translateX(-50%)"
        };
    }
    if (emplacement === "right-top") {
        return {
            bottom: 0,
            left: "".concat(buttonWidth + gap, "px")
        };
    }
    if (emplacement === "left-top") {
        return {
            bottom: 0,
            right: "".concat(buttonWidth + gap, "px")
        };
    }
    if (emplacement === "bottom-left") {
        return {
            top: 0,
            right: "".concat(buttonWidth + gap, "px")
        };
    }
    return {
        left: 0
    };
}
function GenericDropDown(param) {
    var wrapperClassName = param.wrapperClassName, buttonClassName = param.buttonClassName, buttonNode = param.buttonNode, itemsClassName = param.itemsClassName, children = param.children, disabled = param.disabled, _emplacement = param.emplacement, emplacement = _emplacement === void 0 ? "bottom" : _emplacement, _gap = param.gap, gap = _gap === void 0 ? 10 : _gap;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isOpen = ref[0], setIsOpen = ref[1];
    var wrapperRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var buttonRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), buttonWidth = ref1[0], setButtonWidth = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), buttonHeight = ref2[0], setButtonHeight = ref2[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var handleClickOutside = function handleClickOutside(param) {
            var target = param.target;
            if ((0,_swc_helpers_src_instanceof_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(target, Node)) {
                var ref;
                if (!(wrapperRef === null || wrapperRef === void 0 ? void 0 : (ref = wrapperRef.current) === null || ref === void 0 ? void 0 : ref.contains(target))) {
                    setIsOpen(false);
                }
            }
        };
        document.addEventListener("click", handleClickOutside, true);
        return function() {
            return document.removeEventListener("click", handleClickOutside, true);
        };
    }, [
        wrapperRef
    ]);
    // TODO check about useLayoutEffect and its implications for server side rendering
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) {
            setButtonWidth(buttonRef.current.offsetWidth);
            setButtonHeight(buttonRef.current.offsetHeight);
        }
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        ref: wrapperRef,
        className: (0,_lib_classnames__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("relative", wrapperClassName),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                ref: buttonRef,
                type: "button",
                disabled: disabled,
                onClick: function() {
                    return setIsOpen(!isOpen);
                },
                className: (0,_lib_classnames__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(buttonClassName),
                children: buttonNode
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (0,_lib_classnames__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
                    hidden: !isOpen
                }, "absolute z-50", itemsClassName),
                style: getStyle(emplacement, buttonWidth, buttonHeight, gap),
                children: children
            })
        ]
    });
}


/***/ }),

/***/ 70952:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Prose; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _lib_classnames__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(370);


function Prose(param) {
    var className = param.className, children = param.children;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (0,_lib_classnames__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)("\n        prose max-w-none text-lg lg:prose-xl font-serif dark:prose-invert\n        prose-h1:font-sans prose-h1:lg:text-4xl prose-h1:text-2xl\n        prose-h2:font-sans prose-h2:text-lg prose-h2:lg:text-2xl prose-h2:mt-4 prose-h2:mb-2\n        prose-h3:font-sans prose-h3:text-lg prose-h3:lg:text-xl\n        prose-h4:font-sans prose-h4:text-lg\n        prose-h5:font-sans prose-h5:text-base\n        prose-h6:font-sans prose-h6:text-sm\n        prose-lead:font-sans prose-lead:text-gray-500 prose-lead:lg:text-xl prose-lead:text-lg\n        prose-figcaption:font-sans prose-figcaption:text-gray-500 prose-figcaption:!text-xs\n        prose-figure:my-2 prose-figure:lg:my-8\n        prose-img:my-2", className),
        children: children
    });
}


/***/ }),

/***/ 4683:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Label; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);

function Label(param) {
    var htmlFor = param.htmlFor, children = param.children, className = param.className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("label", {
        htmlFor: htmlFor,
        className: "block mb-2 text-sm font-bold text-gray-900 dark:text-gray-300 ".concat(className),
        children: children
    });
}


/***/ }),

/***/ 16825:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ NavOption; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _lib_classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(370);
/* harmony import */ var _elements_Button__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(74340);
/* harmony import */ var _elements_Link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(6553);




function NavOption(param) {
    var getUrl = param.getUrl, className = param.className, children = param.children, onClick = param.onClick, target = param.target;
    if (getUrl) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Link__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
            href: getUrl(),
            type: "alternative",
            target: target,
            onClick: onClick,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                className: (0,_lib_classnames__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("hover:cursor-pointer", className),
                children: children
            })
        });
    }
    if (onClick) {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_elements_Button__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP, {
            color: "transparent",
            size: "no-size",
            className: (0,_lib_classnames__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)("w-full", className),
            onClick: onClick,
            children: children
        });
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        children: children
    });
}


/***/ }),

/***/ 47727:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"menuBar":"MenuBar_menuBar__tybhC","divider":"MenuBar_divider__7qtkI"};

/***/ })

}]);